// Tablero común: filtros guardados por usuario (tabla board_saved_filters, M50). La RLS deja a cada usuario ver y
// cambiar solo los suyos; aquí además se consulta solo lo del usuario y se descarta cualquier fila ajena.

import { supabase } from '../../supabaseClient';
import type { ConfigTablero } from './tablero-logica';

export interface FiltroGuardado { id: string; user_id: string; name: string; config: ConfigTablero }

/** Solo los filtros del usuario (defensa adicional a la RLS). */
export const filtrosDelUsuario = <F extends { user_id: string }>(filas: F[], userId: string | null): F[] =>
  userId ? filas.filter(f => f.user_id === userId) : [];

export async function cargarFiltros(companyId: string, userId: string | null, board: string): Promise<FiltroGuardado[]> {
  if (!companyId || !userId) return [];
  const { data, error } = await supabase.from('board_saved_filters').select('id, user_id, name, config')
    .eq('company_id', companyId).eq('user_id', userId).eq('board', board).order('name');
  if (error) return [];
  return filtrosDelUsuario((data ?? []) as FiltroGuardado[], userId);
}

export async function guardarFiltro(companyId: string, userId: string, board: string, nombre: string, config: ConfigTablero): Promise<void> {
  const name = nombre.trim().slice(0, 80);
  if (!name) throw new Error('Ponle un nombre al filtro.');
  const { error } = await supabase.from('board_saved_filters')
    .upsert({ company_id: companyId, user_id: userId, board, name, config }, { onConflict: 'user_id,company_id,board,name' });
  if (error) throw new Error('No se pudo guardar el filtro. Intenta de nuevo.');
}

export async function borrarFiltro(id: string): Promise<void> {
  const { error } = await supabase.from('board_saved_filters').delete().eq('id', id);
  if (error) throw new Error('No se pudo borrar el filtro. Intenta de nuevo.');
}
